import {
  initialState,
  Actions,
  State,
  DELETE_CONTACT,
  DELETE_CONTACT_SUCCESS,
  DELETE_CONTACT_ERROR,
  RESET_DELETE_CONTACT,
} from '../../types/contact/delete'

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case DELETE_CONTACT:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      }
    case DELETE_CONTACT_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      }
    case DELETE_CONTACT_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      }
    case RESET_DELETE_CONTACT:
      return {
        ...state,
        ...initialState,
      }
    default:
      return state
  }
}

export default reducers
